import axios from 'axios'
import { Toast } from 'vant'
// import secret from './secret'

const BASE_URL = 'http://192.168.2.20:8888' // 将这里替换为你的API基础URL http://192.168.2.20:8888/api/shop/items

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 5000, // 请求超时时间，单位毫秒
  headers: {
    'Content-Type': 'application/json'
    // 在这里可以添加其他需要的请求头
  }
})

// http request 拦截器
axiosInstance.interceptors.request.use(

  config => {
    let xtoken = localStorage.getItem('utoken')
    console.log('xtoken', xtoken)
    xtoken = (xtoken === 'undefined' || xtoken == null) ? '' : xtoken
    console.log(xtoken)
    console.log(config)
    if (xtoken) {
      //   function time (time = +new Date()) {
      //     var date = new Date(time + 8 * 3600 * 1000) // 增加8小时
      //     return date.toJSON().substr(0, 19).replace('T', ' ')
      //   }
      //   let yToken = {'time': time(+new Date()), 'userToken': xtoken}
      // let yToken = {'userToken': xtoken}

      // let accessToken = secret.encrypt(JSON.stringify(yToken), xtoken.slice(0, 16))
      config.headers['token'] = xtoken
      // config.headers['accessToken'] = accessToken
    }
    // xtoken = (xtoken === 'undefined') ? '' : xtoken
    //   if (config.method === 'post') {
    //     config.params = {
    //       token: xtoken,
    //       ...config.params
    //     }
    //   } else if (config.method === 'get') {
    //     config.params = {
    //       token: xtoken,
    //       ...config.params
    //     }
    //   }
    return config
  },
  err => {
    return Promise.reject(err)
  })

// 封装GET请求
export const get = async (url, params) => {
  try {
    const response = await axiosInstance.get(url, { params })
    return response.data
  } catch (error) {
    // 处理错误
    console.error('GET Request Error:', error)
    throw error
  }
}

// 封装POST请求
export const post = async (url, data) => {
  try {
    const response = await axiosInstance.post(url, data)
    if (response.data.err !== undefined) {
      Toast(response.data.err)
      return undefined
    }
    return response.data
  } catch (error) {
    // 处理错误
    console.error('POST Request Error:', error, url)
    if (url.indexOf('/api/user/item/active') > -1) {
      Toast('使用失败，可能已过期！')
    } else {
      Toast('失败')
    }

    throw error
  }
}

axiosInstance.interceptors.response.use(
  response => {
    if (response.data == null && response.config.responseType === 'json' && response.request.responseText != null) {
      try {
        // eslint-disable-next-line no-param-reassign
        response.data = JSON.parse(response.request.responseText)
      } catch (e) {
        // ignored
      }
    }
    return response
  },
  error => { // 默认除了2XX之外的都是错误的，就会走这里
    if (error.response) {
      switch (error.response.status) {
        case 401:
        //   alert('未登录')
          window.location.href = '#/login'
          // router.replace({ path: '/login' })
      }
    }
    return Promise.reject(error.response)
  }
)

// 在这里可以添加其他HTTP请求方法，如PUT、DELETE等

export default axiosInstance



// WEBPACK FOOTER //
// ./src/utils/httpService.js